function openHamburger() {
    const body = document.body;
    const backdrop = document.querySelector(".header-hamburger-backdrop");

    body.classList.add("overflow-container");
    backdrop.classList.add("open");
}

function closeHamburger() {
    const body = document.body;
    const backdrop = document.querySelector(".header-hamburger-backdrop");

    body.classList.remove("overflow-container");
    backdrop.classList.remove("open");
}